export const fiscalData = {
	title: "DADOS FISCAIS",
	fields: {
		ncm: {
			label: "NCM",
			placeholder: "Digite o NCM",
			tooltip: "Nomenclatura Comum do Mercosul",
		},
		cest: {
			label: "CEST",
			placeholder: "Digite o CEST",
			tooltip: "Código Especificador da Substituição Tributária",
		},
		fiscalProfile: {
			label: "Perfil fiscal",
			placeholder: "Selecione o perfil fiscal",
			loading: "Carregando...",
			tooltip:
				"Conjunto de dados que descreve a situação tributária de uma pessoa ou empresa.",
		},
		fiscalGroup: {
			label: "Grupo fiscal",
			placeholder: "Selecione o grupo fiscal",
			loading: "Carregando...",
			tooltip:
				"Grupo fiscal é um código que classifica produtos de acordo com sua tributação.",
		},
	},
};
